import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { DeviceActiveSyncsResolverActions } from './device-active-syncs-store/devices-active-syncs.actions';

@Injectable({ providedIn: 'root' })
export class DeviceActiveSyncCountResolver {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    this.store.dispatch(DeviceActiveSyncsResolverActions.deviceActiveSyncCountRequested());
    return of(true);
  }
}
